import { useCSVInboxTypes } from './csvInboxHooks'

export const useRouteOptions = () => {
    // Always fetch inbox types to build dynamic routes
    const { data: inboxTypes = [], isLoading } = useCSVInboxTypes(true)

    // Build independent route options from inbox types
    // Each type becomes its own parent route (e.g., /GroupEligibility, not /all/GroupEligibility)
    const dynamicRoutes = inboxTypes
        .filter((type) => type.active !== false) // Only include active types
        .map((type) => ({
            name: type.name, // Use name for route identifier
            title: type.friendlyName || type.name, // Use friendlyName if available, fallback to name
            titleKey: type.friendlyName || type.name, // For translation
            icon: 'ApplicationsSmall',
            route: `/${type.name}`, // Direct route path: /GroupEligibility
            csvInboxTypeID: type.csvInboxTypeID, // Store ID for filter syncing
            children: [
                {
                    title: type.friendlyName || type.name,
                    titleKey: type.friendlyName || type.name,
                    route: `/${type.name}`,
                    csvInboxTypeID: type.csvInboxTypeID,
                },
            ],
            dataTestId: `dropdown-menu-item-${type.name}`,
        }))

    // Always include "all" route as the first option
    const routeOptions = [
        {
            name: 'all',
            title: 'All',
            titleKey: 'All',
            icon: 'ApplicationsSmall',
            route: '/all',
            children: [
                {
                    title: 'Inbox',
                    titleKey: 'CSVInbox',
                    route: '/all',
                },
            ],
            dataTestId: 'dropdown-menu-item-all',
        },
        // Add dynamic routes as separate independent parent routes
        ...dynamicRoutes,
    ]

    return { routeOptions, isLoading }
}
